import {IconProps} from './types';

const Celebrate = ({fill = 'currentColor', className, width = 22, height = 22}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20.9408 22.2951"
        fill="none"
        stroke={fill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M4.88527 14.6155L3.04413 21.0715M0.500129 20.3447L5.58641 21.795M2.20584 9.29438L5.52299 0.500095L11.7853 2.28295L9.9647 11.5058C9.85818 12.0569 9.63824 12.5798 9.31884 13.0414C8.99945 13.503 8.58758 13.8931 8.10938 14.187C7.63117 14.4809 7.09709 14.6722 6.54102 14.7487C5.98496 14.8252 5.41906 14.7853 4.87926 14.6314C4.33945 14.4776 3.83753 14.2132 3.40536 13.855C2.97319 13.4968 2.6202 13.0527 2.36881 12.5508C2.11742 12.049 1.97312 11.5003 1.94506 10.9397C1.91701 10.3791 2.00581 9.81883 2.20584 9.29438Z" />
        <path d="M3.86699 4.88352L10.8716 6.89781" />
        <path d="M13.1567 14.355C13.8853 14.7144 14.7052 14.8464 15.5098 14.7337C16.3145 14.621 17.0666 14.2689 17.6684 13.7231C18.2702 13.1773 18.6939 12.463 18.8845 11.6732C19.075 10.8834 19.0235 10.0545 18.7367 9.29438L15.4161 0.500095L14.4287 0.779524M16.0556 14.6155L17.8967 21.0715M20.4407 20.3447L15.3544 21.795M17.0738 4.9041L14.2127 5.72695" />
    </svg>
);

export default Celebrate;
